import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/atencion-al-cliente/AtencionAlClienteClient.tsx");
